import { render, staticRenderFns } from "./MailSettingsCreateOrUpdate.vue?vue&type=template&id=18017e77&"
import script from "./MailSettingsCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./MailSettingsCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports